<div class="box">
  <div class="box-row header">
    <app-header-bar [backRoute]="'/workflows'" [title]="title" [autoTranslateTitle]="false"></app-header-bar>
  </div>
  <div class="content mt-2 mb-3">
    <div class="row">
      <app-datatable
        [dataSource]="source"
        [columns]="columns"
        [identifier]="'workflow-executions'"
        (showEvent)="show($event.valueOf())"
        [actionNew]="false"
        [searchEnabled]="false"
      >
        <app-empty-table [icon]="'event_list'" [emptyText]="'workflow.execution.empty_text' | translate"> </app-empty-table>
      </app-datatable>

      <app-error [error]="error"></app-error>
    </div>
  </div>
</div>
